//#region import
import React, { Fragment, createContext, useContext, useEffect, useState } from 'react';
import { ProjectContext } from '../ProjectRequestFrom';
import { Convert, DefaultArrayEmpty, FnAxios, FnDialog, I18n, ParseHtml } from 'utilities/utilities';
import { APIStatusCode, EnumProjectPanel, EnumProjectStatusID, EnumSaveModeProject, EnumStatusMode, I18NextNs } from 'enum/enum';
import { ApiProject } from 'enum/api';
import { Chip, Divider, Grid, Tooltip, Typography } from '@mui/material';
import { BtnAdd, BtnCancel, BtnDraft, BtnEdit, BtnSave, BtnSend, BtnSendRequest } from 'components/Button/ButtonAll';
import ErrorIcon from '@mui/icons-material/Error';
import { FormProvider, useForm } from 'react-hook-form';
import { TextBoxItem } from 'components/Input/TextBox';
import { TextAreaItem } from 'components/Input/TextArea';
import { SelectItem } from 'components/Input/Select/SelectItem';
import AccordionPanel from '../components/AccordionPanel';
import { BtnDeleteOnTable, BtnEditOnTable, BtnViewDataOnTable } from 'components/Button/ButtonTable';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { List as LINQ } from "linqts";
import InputNumberItem from 'components/Input/InputNumber';
import { useLocation } from 'react-router';
import NumberInputCustom from '../components/NumberInputCustom';
//#endregion

const Panel10 = () => {
    const { 
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isChangePanel12,
        setisChangePanel12,
        isSubmit,
        setisSubmit,
        ObjStepFlowProject,
        isModeSecretary,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    
    const [isEditSecretary, setisEditSecretary] = useState(null);
    const [isComplete, setisComplete] = useState(null);    
    const [arrDataPositionTeam, setarrDataPositionTeam] = useState([]);    
    const [arrDataUserUnit, setarrDataUserUnit] = useState([]);   
    const [isPosition, setisPosition] = useState(null);

    const [nProjectTeamIDEdit, setnProjectTeamIDEdit] = useState(0);
    const [ObjTeamIDEdit, setObjTeamIDEdit] = useState(null);
    const [arrProjectTeam, setarrProjectTeam] = useState([]);    
    const [DataRowTeam, setDataRowTeam] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sProjectManageSustainable: null,
        } as any,
    });

    useEffect(() => {
        setisEditSecretary(isModeSecretary === true ? false : isPermission);
    }, [isModeSecretary]);

    useEffect(() => {
        GetFormInitial();
    }, []);

    useEffect(() => {
        if (nProjectID !== 0) GetFormInitial(); handleGetFormProjectID();
    }, [nProjectID]);

    const GetFormInitial = () => {
        AxiosFn.Get(ApiProject.GetFormInitialProjectPanel10, { nProjectID : nProjectID }, (result) => { 
            // console.log("position", result.lstPositionTeamID)
            setarrDataPositionTeam(result.lstPositionTeamID);
            setarrDataUserUnit(result.lstUserUnitID);
            // handleGetTableProject(dataRow);
        });
    }

    const handleGetFormProjectID = () => {
        // DialogFn.BlockUI();
        AxiosFn.Get(ApiProject.GetFormProjectID_Panel10, { nProjectID : nProjectID }, (result) => {
            // DialogFn.UnBlockUI();
            setnProjectID(result.objResult.nProjectID);
            // setnStatusID(result.objResult.nStatusID);
            setisComplete(result.objResult.isComplete);

            setarrProjectTeam(result.objResult.lstProjectTeam);
            setDataRowTeam({
                ...initRows,
                nDataLength: result.objResult.lstProjectTeam.length,
                arrRows: result.objResult.lstProjectTeam,
            });

            form.setValue("sProjectManageSustainable", result.objResult.sProjectManageSustainable);
        });
    };

    const formTeam = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            nPositionID: null,
            sOtherPosition: null,
            nUserID: null,
            sTitle: null,
            sFName: null,
            sLName: null,
            sUnitName: null,
            sTelNo_Team: null,
            sEmail: null,
        } as any,
    });

    const dataColumnTeam: any = [
        {
            field: "isEdit",
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 80,
            getActions: (item) => {
                return [          
                    !item.row.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true) ?
                        <>
                            <BtnDeleteOnTable
                                key={"btnDelete_Team_" +item.row.sID}
                                id={"btnDelete_Team_" +item.row.sID}
                                onClick={() => onDeleteTeam(item.row.nID, EnumStatusMode.Delete)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        
                            <BtnEditOnTable
                                key={"btnEdit_Team_" +item.row.sID}
                                id={"btnEdit_Team_" +item.row.sID}
                                onClick={() => onEditTeam(item.row, EnumStatusMode.Edit)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        </>
                    :
                        <BtnViewDataOnTable
                            key={"btnView_Team_" +item.row.sID}
                            id={"btnView_Team_" +item.row.sID}
                            onClick={() => onEditTeam(item.row, EnumStatusMode.View)}
                            // IsDisabled={!isPermission || isEditSecretary === false}
                        />
                ];
            },
        },
        {
            field: "nNo",
            headerName: "ที่",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 1,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
        {
            field: "sUserName",
            headerName: "ชื่อ-นามสกุล",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 3,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },      
        {
            field: "sOtherPosition",
            headerName: "ตำแหน่ง",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 2,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },    
        {
            field: "sUnitName",
            headerName: "หน่วยงานต้นสังกัด",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 2,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        }, 
        {
            field: "sTelNo",
            headerName: "เบอร์โทรศัพท์",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 2,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },  
        // {
        //     field: "sEmail",
        //     headerName: "อีเมล",
        //     headerAlign: "center",
        //     align: "left",
        //     sortable: false,
        //     flex: 2,
        //     disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        // },        
    ];

    const onAddTeam = () => {
        let ObjFormTeam = formTeam.getValues();
        let ObjDuplicatePosition = arrProjectTeam.filter((f) => !f.isDelete && (nProjectTeamIDEdit !== 0 ? f.nID !== nProjectTeamIDEdit : true) && ObjFormTeam.nPositionID === 87 ? f.nPositionID === ObjFormTeam.nPositionID : false);
        if ((ObjDuplicatePosition || []).length > 0) return DialogFn.Warning("หัวหน้าโครงการ มีได้แค่ 1 คนเท่านั้น");
        let ObjDuplicate = arrProjectTeam.filter((f) => !f.isDelete && (nProjectTeamIDEdit !== 0 ? f.nID !== nProjectTeamIDEdit : true) && 
                                                        (ObjFormTeam.nPositionID === 90 ? (f.sTitle === ObjFormTeam.sTitle && f.sFName === ObjFormTeam.sFName && f.sLName === ObjFormTeam.sLName) : f.nUserID === ObjFormTeam.nUserID ));
        if ((ObjDuplicate || []).length === 0)
        {      
            //#region Old
            // let nProjectTeamID = 0;
            // let dataRow = DataRowTeam;
            // let arrTeam = DefaultArrayEmpty(arrProjectTeam);
            // let nMaxID = new LINQ<any>(arrTeam).Any() ? new LINQ<any>(arrTeam).Max((m) => m.nID) + 1 : 1;
            // if (nProjectTeamIDEdit) {
            //     arrTeam = arrTeam.filter((f) => f.nID !== nProjectTeamIDEdit);
            //     nProjectTeamID = arrProjectTeam.find((f) => f.nID === nProjectTeamIDEdit)?.nProjectTeamID;
            //     nMaxID = nProjectTeamIDEdit;
            // }

            // let ObjPosition = null;
            // let ObjUserID = null;
            // if (ObjFormTeam.nUserID !== null)
            // {
            //     ObjPosition = arrDataPositionTeam.find((f) => f.value === ObjFormTeam.nPositionID);
            //     ObjUserID = arrDataUserUnit.find((f) => f.nUserID === ObjFormTeam.nUserID);
            // }

            // let obj = {
            //     isDelete: false,
            //     isEdit: false, 
            //     sID: nMaxID.toString(),
            //     nNo: nMaxID,
            //     nID: nMaxID,
            //     nProjectTeamID: nProjectTeamID,              
            //     nPositionID: Convert.StringToInt(ObjFormTeam.nPositionID),
            //     nUserID: Convert.StringToIntOrNull(ObjFormTeam.nUserID),
            //     sOtherPosition: isPosition === true ? ObjFormTeam.sOtherPosition : ObjPosition?.label,
            //     sTitle: isPosition === true ? ObjFormTeam.sTitle : ObjUserID?.sTitle,
            //     sFName: isPosition === true ? ObjFormTeam.sFName : ObjUserID?.sFName,
            //     sLName: isPosition === true ? ObjFormTeam.sLName : ObjUserID?.sLName,
            //     sUnitName: isPosition === true ? ObjFormTeam.sUnitName : ObjUserID?.sUnitName,
            //     sTelNo: isPosition === true ? ObjFormTeam.sTelNo_Team : ObjUserID?.sTelNo,
            //     sEmail: isPosition === true ? ObjFormTeam.sEmail : ObjUserID?.sEmail,
            //     sUserName: isPosition === true ? ObjFormTeam.sTitle + " " + ObjFormTeam.sFName + " " + ObjFormTeam.sLName : ObjUserID?.label,
            // };

            // let nNo = 1;
            // let result = [...arrTeam, obj];
            // // result.forEach(f => f.nNo = nNo++);
            // result.forEach(f => {
            //     if (f.isDelete === true) {
            //         f.nNo = 0;
            //     } else {
            //         f.nNo = nNo++;
            //     }
            // });
            // let arrTable = result.filter(f => !f.isDelete);
            // setDataRowTeam({
            //     ...dataRow,
            //     nDataLength: arrTable.length,
            //     arrRows: arrTable,
            // });
            // setnProjectTeamIDEdit(0);
            // setObjTeamIDEdit(null);
            // setarrProjectTeam(result);
            // onClearFieldTeam();
            //#endregion
        
            //#region New
            let nProjectTeamID = 0;
            let dataRow = DataRowTeam;
            let arrTeam = DefaultArrayEmpty(arrProjectTeam);

            let ObjPosition = null;
            let ObjUserID = null;
            if (ObjFormTeam.nUserID !== null) {
                ObjPosition = arrDataPositionTeam.find((f) => f.value === ObjFormTeam.nPositionID);
                ObjUserID = arrDataUserUnit.find((f) => f.nUserID === ObjFormTeam.nUserID);
            }

            if (nProjectTeamIDEdit) //Edit
            {
                const oEditIndex = arrTeam.findIndex((item) => item.nID === nProjectTeamIDEdit);
                if (oEditIndex !== -1) {
                    arrTeam[oEditIndex].nPositionID = Convert.StringToInt(ObjFormTeam.nPositionID);
                    arrTeam[oEditIndex].nUserID = Convert.StringToIntOrNull(ObjFormTeam.nUserID);
                    arrTeam[oEditIndex].sOtherPosition = isPosition === true ? ObjFormTeam.sOtherPosition : ObjPosition?.label;
                    arrTeam[oEditIndex].sTitle = isPosition === true ? ObjFormTeam.sTitle : ObjUserID?.sTitle;
                    arrTeam[oEditIndex].sFName = isPosition === true ? ObjFormTeam.sFName : ObjUserID?.sFName;
                    arrTeam[oEditIndex].sLName = isPosition === true ? ObjFormTeam.sLName : ObjUserID?.sLName;
                    arrTeam[oEditIndex].sUnitName = isPosition === true ? ObjFormTeam.sUnitName : ObjUserID?.sUnitName;
                    arrTeam[oEditIndex].sTelNo = isPosition === true ? ObjFormTeam.sTelNo_Team : ObjUserID?.sTelNo;
                    arrTeam[oEditIndex].sEmail = isPosition === true ? ObjFormTeam.sEmail : ObjUserID?.sEmail;
                    arrTeam[oEditIndex].sUserName = isPosition === true ? ObjFormTeam.sTitle + " " + ObjFormTeam.sFName + " " + ObjFormTeam.sLName : ObjUserID?.label;
                    arrTeam[oEditIndex].nAffiliationUnitID = isPosition === true ? null : ObjUserID?.nAffiliationUnitID;
                }
                let arrTable = arrTeam.filter(f => !f.isDelete);
                setDataRowTeam({
                    ...dataRow,
                    nDataLength: arrTable.length,
                    arrRows: arrTable,
                });
            } 
            else //Add
            {            
                let nMaxID = new LINQ<any>(arrTeam).Any() ? new LINQ<any>(arrTeam).Max((m) => m.nID) + 1 : 1;            
                let obj = {
                    isDelete: false,
                    isEdit: false, 
                    sID: nMaxID.toString(),
                    nNo: nMaxID,
                    nID: nMaxID,
                    nProjectTeamID: nProjectTeamID,              
                    nPositionID: Convert.StringToInt(ObjFormTeam.nPositionID),
                    nUserID: Convert.StringToIntOrNull(ObjFormTeam.nUserID),
                    sOtherPosition: isPosition === true ? ObjFormTeam.sOtherPosition : ObjPosition?.label,
                    sTitle: isPosition === true ? ObjFormTeam.sTitle : ObjUserID?.sTitle,
                    sFName: isPosition === true ? ObjFormTeam.sFName : ObjUserID?.sFName,
                    sLName: isPosition === true ? ObjFormTeam.sLName : ObjUserID?.sLName,
                    sUnitName: isPosition === true ? ObjFormTeam.sUnitName : ObjUserID?.sUnitName,
                    sTelNo: isPosition === true ? ObjFormTeam.sTelNo_Team : ObjUserID?.sTelNo,
                    sEmail: isPosition === true ? ObjFormTeam.sEmail : ObjUserID?.sEmail,
                    sUserName: isPosition === true ? ObjFormTeam.sTitle + " " + ObjFormTeam.sFName + " " + ObjFormTeam.sLName : ObjUserID?.label,
                    nAffiliationUnitID: isPosition === true ? null : ObjUserID?.nAffiliationUnitID,
                };

                let nNo = 1;
                let result = [...arrTeam, obj];
                // result.forEach(f => f.nNo = nNo++);
                result.forEach(f => {
                    if (f.isDelete === true) {
                        f.nNo = 0;
                    } else {
                        f.nNo = nNo++;
                    }
                });
                let arrTable = result.filter(f => !f.isDelete);
                setDataRowTeam({
                    ...dataRow,
                    nDataLength: arrTable.length,
                    arrRows: arrTable,
                });
                setarrProjectTeam(result);
            }
            setnProjectTeamIDEdit(0);
            setObjTeamIDEdit(null);
            onClearFieldTeam_Add();
            //#endregion
        } 
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearFieldTeam_Add = () => {
        Object.keys(formTeam.getValues()).forEach((key) => {
            formTeam.setValue(key, null);
            formTeam.clearErrors(key);
        });
        setisPosition(null);
    };

    const onClearFieldTeam = () => {
        Object.keys(form.getValues()).forEach((key) => {
            form.setValue(key, null);
            form.clearErrors(key);
        });
        Object.keys(formTeam.getValues()).forEach((key) => {
            formTeam.setValue(key, null);
            formTeam.clearErrors(key);
        });
        setisPosition(null);
    };

    const onEditTeam = (ObjData, nModeID : EnumStatusMode) => {
        setnProjectTeamIDEdit(ObjData.nID);   
        let ObjTeam = {
            isDelete: ObjData.isDelete,
            isEdit: true, 
            sID: ObjData.sID,
            nNo: ObjData.nNo,
            nID: ObjData.nID,
            nProjectTeamID: ObjData.nProjectTeamID,           
            nPositionID: ObjData.nPositionID,
            sOtherPosition: ObjData.sOtherPosition,
            nUserID: ObjData.nUserID,
            sTitle: ObjData.sTitle,
            sFName: ObjData.sFName,
            sLName: ObjData.sLName,
            sUnitName: ObjData.sUnitName,
            sTelNo: ObjData.sTelNo,
            sEmail: ObjData.sEmail,
            sUserName: ObjData.sUserName,
            nAffiliationUnitID: ObjData.nAffiliationUnitID,
        };
        setObjTeamIDEdit(ObjTeam);

        formTeam.setValue("nPositionID", ObjTeam.nPositionID);
        if (ObjTeam.nPositionID === 90)
        {
            setisPosition(true);
            formTeam.setValue("sOtherPosition", ObjTeam.sOtherPosition);
            formTeam.setValue("sTitle", ObjTeam.sTitle);
            formTeam.setValue("sFName", ObjTeam.sFName);
            formTeam.setValue("sLName", ObjTeam.sLName);
            formTeam.setValue("sUnitName", ObjTeam.sUnitName);
            formTeam.setValue("sTelNo_Team", ObjTeam.sTelNo);
            formTeam.setValue("sEmail", ObjTeam.sEmail);
        } else {
            setisPosition(false);
            formTeam.setValue("nUserID", (ObjTeam.nUserID === 0 ? null : ObjTeam.nUserID));
        }     
        
        document.getElementById("myDivTeam").scrollIntoView({ behavior: "smooth" });
    }

    const onDeleteTeam = (nID, nModeID : EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrTeamData: any[] = arrProjectTeam;
            let result = arrTeamData.filter((f) => f.nID !== nID);
            let arrDelete = arrTeamData.filter((f) => f.nID === nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
                item.nNo = 0;
            })
            let nNo = 1;
            result.filter(f => !f.isDelete).forEach((f) => {
                f.nNo = nNo++;
            });
            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => {});
            setDataRowTeam({
                ...DataRowTeam,
                nDataLength: result.filter(f => !f.isDelete).length,
                arrRows: [...result.filter(f => !f.isDelete)],
            });
            setarrProjectTeam([...result, ...arrDelete]);
        });
    };

    const handleSubmit = (nModeID: EnumSaveModeProject) => {
        // 87 หัวหน้าโครงการ
        // 89 ผู้ประสานงานโครงการ
        // 90 อื่นๆ (ระบุ)
        let ObjPositionID_87 = arrProjectTeam.filter(f => !f.isDelete && f.nPositionID === 87);
        let ObjPositionID_89 = arrProjectTeam.filter(f => !f.isDelete && f.nPositionID === 89);
        if (((ObjPositionID_87 ?? []).length === 0 || (ObjPositionID_89 ?? []).length === 0) && nModeID === EnumSaveModeProject.Submit) {
            return DialogFn.Warning("กรุณาเพิ่มข้อมูลอย่างน้อย 2 รายการ คือตำแหน่ง หัวหน้าโครงการ, ผู้ประสานงานโครงการ");
        } 
        let ObjData = form.getValues(); 
        let param = {
            nProjectID: nProjectID,
            nSaveModeProject: nModeID,
            nPanelID: EnumProjectPanel.Panel10,
            isFastTrack: isFastTrack,

            lstProjectTeam: arrProjectTeam ?? [],
            sProjectManageSustainable: ObjData.sProjectManageSustainable,

            sLocation: location.pathname,
        };
        DialogFn.Submit(nModeID === EnumSaveModeProject.Draft
                        ? I18n.SetText("Message.ConfirmSaveDraft", I18NextNs.labelComponent) 
                        : I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectPanel10, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        setnProjectID(result.objResult?.nProjectID);
                        setisComplete(nModeID === EnumSaveModeProject.Draft ? false : true);
                        // setarrisEditPanel({nPanelID: 10, isEdit: false});
                        setisChangePanel12(true);
                        setisSubmit(isSubmit === true ? false : true);
                        if(isEditSecretary && isModeSecretary === true) setisEditSecretary(false);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    return (
        <AccordionPanel
            header={"10. การบริหารโครงการ"}
            isExpanded={true} 
            // SubHeader={}
            color="white"
            bgColor="rgb(102,151,245)"
            background="#5598fc"
            expandIconColor="white"
            borderColor="1px solid #5598fc"
            borderRadius="18px !important"
            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
            SubHeaderStatus={
                (isComplete !== null &&
                    <Chip
                        size="small"
                        label={ParseHtml(isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง" : "")}
                        style={{
                            color: "white",
                            backgroundColor: (isComplete === false ? '#f18c3a' : isComplete === true ? "#0a9914" : ""),
                            fontSize: "14px"
                        }}
                    />     
                )      
            }
            isDisabled={nProjectID === 0}
        >
            <Grid id={"myDivPanel10"} item xs={12} md={12} container spacing={1} style={{ padding: '2%', paddingBottom: '1%', }}>
                <FormProvider {...form}>
                    <Grid item xs={12} md={12} container spacing={2}>
                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                            <Grid item>
                                <Typography variant='h6' color={'#0000a5'}>การบริหารโครงการ</Typography>
                            </Grid>
                            <Grid item>
                                <Tooltip placement={'right-end'} title={"ระบุผู้บริหารโครงการ ผู้ประสานงาน และผู้ที่เกี่ยวข้องในการดำเนินงานโครงการ ในกรณีที่มีบุคลากรจากหน่วยงานอื่นเป็นผู้ร่วมโครงการ จำเป็นต้องมีหนังสือยินยอมจากหัวหน้า หน่วยงานต้นสังกัดของบุคคลนั้น นอกจากนี้ จะต้องนำเสนอแนวทางการบริหารโครงการเพื่อให้เกิดความต่อเนื่องและยั่งยืน เช่น การบรรลุแผนงานโครงการไว้ในแผนงานของท้องถิ่นเพื่อสนับสนุนให้ชุมชนดำเนินการต่อไปหลังสิ้นสุดโครงการตามตัวอย่างตารางด้านล่าง"}>
                                    <ErrorIcon color='primary'/>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Divider />
                            </Grid>
                        </Grid>    
                        <Grid id={"myDivTeam"} item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                            <AccordionPanel
                                header={"10.1 บุคคลที่เกี่ยวข้องในการดำเนินงานโครงการ"}
                                isExpanded={false} 
                                color="white"
                                bgColor="rgb(102,151,245)"
                                background="#e79a09"
                                expandIconColor="white"
                                borderColor="1px solid #e79a09"
                                borderRadius="20px !important"
                                boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                                boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                            >           
                                <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                                    <FormProvider {...formTeam}>
                                        <Grid item xs={12} md={12} container spacing={2}>
                                            <Grid item xs={12} md={12}>
                                                <Typography variant='body2' color={'red'}>หมายเหตุ : กรณีที่หัวหน้าโครงการ หรือผู้ประสานงานโครงการ จะต้องสมัคร Account ผ่านหน้าสมัครเข้าใช้งานระบบก่อนทุกครั้ง</Typography>
                                            </Grid>  
                                            {(((isPermission && isModeSecretary !== true) || isEditSecretary === true) || nProjectTeamIDEdit !== 0) &&
                                                <Grid item xs={12} md={4}>
                                                    <SelectItem
                                                        id="nPositionID"
                                                        name="nPositionID"
                                                        label={"ตำแหน่ง"}
                                                        required={true}
                                                        options={arrDataPositionTeam}
                                                        onChange={(e) => {
                                                            setisPosition(e?.value === 90);
                                                        }}
                                                        disabled={!isPermission || isEditSecretary === false}
                                                    />
                                                </Grid>
                                            }
                                            {isPosition === false ?
                                                <Grid item xs={12} md={8}>
                                                    <SelectItem
                                                        id="nUserID"
                                                        name="nUserID"
                                                        label={"ชื่อ"}
                                                        required={isPosition === false ? true : false}
                                                        options={arrDataUserUnit}
                                                        disabled={!isPermission || isEditSecretary === false}
                                                    />                             
                                                </Grid>
                                                :
                                                isPosition === true ?
                                                <>
                                                    <Grid item xs={12} md={8}>
                                                        <TextBoxItem
                                                            id="sOtherPosition"
                                                            name="sOtherPosition"
                                                            maxLength={50}
                                                            label="ชื่อตำแหน่ง"
                                                            disabled={!isPermission || isEditSecretary === false}
                                                            required={isPosition === true}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={12} container spacing={2}>
                                                        <Grid item xs={12} md={12} container spacing={2}>
                                                            <Grid item xs={12} md={4}>
                                                                <TextBoxItem
                                                                    id="sTitle"
                                                                    name="sTitle"
                                                                    maxLength={50}
                                                                    label="คำนำหน้า"
                                                                    disabled={!isPermission || isEditSecretary === false}
                                                                    required={isPosition === true}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={4}>
                                                                <TextBoxItem
                                                                    id="sFName"
                                                                    name="sFName"
                                                                    maxLength={50}
                                                                    label="ชื่อ"
                                                                    disabled={!isPermission || isEditSecretary === false}
                                                                    required={isPosition === true}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={4}>
                                                                <TextBoxItem
                                                                    id="sLName"
                                                                    name="sLName"
                                                                    maxLength={50}
                                                                    label="นามสกุล"
                                                                    disabled={!isPermission || isEditSecretary === false}
                                                                    required={isPosition === true}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs={12} md={12} container spacing={2}>
                                                            <Grid item xs={12} md={4}>
                                                                <TextBoxItem
                                                                    id="sUnitName"
                                                                    name="sUnitName"
                                                                    maxLength={250}
                                                                    label="หน่วยงานต้นสังกัด"
                                                                    disabled={!isPermission || isEditSecretary === false}
                                                                    required={isPosition === true}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={4}>
                                                                <TextBoxItem
                                                                    id={"sTelNo_Team"}
                                                                    name={"sTelNo_Team"}
                                                                    type={'text'}
                                                                    label={"เบอร์โทรศัพท์"}
                                                                    isTelNo={true}
                                                                    maxLength={10}
                                                                    pattern={'en-number'}
                                                                    required={isPosition === true}                                                                        
                                                                    disabled={!isPermission || isEditSecretary === false}
                                                                />
                                                                {/* <InputNumberItem
                                                                    id={"sTelNo_Team"}
                                                                    name={"sTelNo_Team"}
                                                                    label={"เบอร์โทรศัพท์"}
                                                                    IsComma={false}
                                                                    IsCanMinus={false}
                                                                    IsAllowScientific={false}
                                                                    type={"Number"}
                                                                    ShowDigits={0}
                                                                    maxDigits={0}
                                                                    maxInteger={10}
                                                                    required={isPosition === true}
                                                                    disabled={!isPermission || isEditSecretary === false}
                                                                /> */}
                                                            </Grid>
                                                            <Grid item xs={12} md={4}>
                                                                <TextBoxItem
                                                                    id={"sEmail"}
                                                                    name={"sEmail"}
                                                                    type={"email"}
                                                                    label={"อีเมล"}
                                                                    maxLength={250}
                                                                    disabled={!isPermission || isEditSecretary === false}
                                                                    required={isPosition === true}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </>
                                                : <></>
                                            }           
                                        </Grid> 
                                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                            {(nProjectTeamIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                                <BtnAdd id={"btnAdd_Table_Team"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่ม"} onClick={formTeam.handleSubmit((e) => onAddTeam(),(err) => console.log("err", err))} />
                                                :
                                                <>
                                                    {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                        <Grid item>
                                                            <BtnSave id={"btnSave_Table_Team"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formTeam.handleSubmit((e) => onAddTeam(),(err) => console.log("err", err))} />
                                                        </Grid>
                                                    }
                                                    {nProjectTeamIDEdit !== 0 &&
                                                        <Grid item>
                                                            <BtnCancel id={"btnCancel_Table_Team"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnProjectTeamIDEdit(0); setObjTeamIDEdit(null); onClearFieldTeam(); }} />
                                                        </Grid>
                                                    }           
                                                </>
                                            }
                                        </Grid>
                                        <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                            <DataGrid
                                                sTableID='TB_ProjectTeam'
                                                columns={dataColumnTeam}
                                                rows={DataRowTeam}
                                                isShowColomnTool={false}
                                                isHiddenToolHead={true}
                                                isShowCheckBox={false}
                                                isHiddenPagination={false}
                                            />
                                        </Grid>
                                    </FormProvider>
                                </Grid>  
                            </AccordionPanel>  
                        </Grid> 
                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item>
                                    <Typography variant='body1'>10.2 แนวทางการบริหารโครงการเพื่อให้เกิดความต่อเนื่องและยั่งยืน</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='body1' color={'red'}>*</Typography>
                                </Grid>                        
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <TextAreaItem
                                    id={"sProjectManageSustainable"}
                                    name={"sProjectManageSustainable"}
                                    label={"10.2 แนวทางการบริหารโครงการเพื่อให้เกิดความต่อเนื่องและยั่งยืน"} 
                                    placeholder={'ต้องแสดงให้เห็นว่าเมื่อดำเนินโครงการเสร็จสิ้นแล้วจะมีองค์กรและกลไกการดำเนินงานหรือเครือข่ายใดเกิดขึ้น เช่น จัดทำแหล่งเรียนรู้ในพื้นที่ชุมชน และการจัดอบรมยุวมัคคุเทศก์หรือให้ความรู้แก่ประชาชนในพื้นที่ เป็นต้น ซึ่งต้องชี้แจงได้ว่าโครงการสามารถดำเนินงานอย่างต่อเนื่องต่อไปได้อย่างไร และมีงบประมาณจากแหล่งทุนใด เพื่อให้เกิดการดำเนินงานต่อเนื่องและ/หรือขยายงานสู่พื้นที่อื่นต่อไป รวมทั้งมีการประสานกับหน่วยงานทุกภาคส่วนที่เกี่ยวข้อง เพื่อสนับสนุน/ช่วยเหลือ/รับผิดชอบเพื่อให้เกิดความต่อเนื่องและยั่งยืนได้อย่างไร'}                              
                                    maxLength={2000}
                                    row={3}
                                    disabled={!isPermission || isEditSecretary === false}
                                    required={true}
                                    IsDisplayLabel={false}
                                />
                            </Grid>
                        </Grid>
                        {nProjectID === 0 || nStatusID === EnumProjectStatusID.nStatusID_11 ?
                            <></>
                            :
                            (isPermission === true &&
                                (isModeSecretary !== true ?
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        {nStatusID === EnumProjectStatusID.nStatusID_0 &&
                                            <Grid item>
                                                <BtnDraft id={"btnDraft_Panel10"} txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Draft) }} />
                                            </Grid>
                                        }
                                        <Grid item>
                                            <BtnSendRequest id={"btnSend_Panel10"} txt={I18n.SetText((nStatusID === EnumProjectStatusID.nStatusID_0 ? "Button.SendProjectPanel" : "Button.Save"), I18NextNs.labelComponent)}  onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit),(err) => console.log("err", err))}/> 
                                            {/* onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit) }} */}
                                        </Grid> 
                                    </Grid>
                                : 
                                    (isModeSecretary === true ?
                                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                            {isEditSecretary === false ?
                                                <Grid item>
                                                    <BtnEdit id={"btnEdit_Panel10"} txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivPanel10").scrollIntoView({ behavior: "smooth" });}} />
                                                </Grid>
                                                :
                                                <>
                                                    <Grid item>
                                                        <BtnCancel id={"btnCancel_Panel10"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); handleGetFormProjectID(); }} />
                                                    </Grid>
                                                    <Grid item>
                                                        <BtnSendRequest id={"btnSend_Panel10"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit),(err) => console.log("err", err))} />
                                                    </Grid>
                                                </>
                                            }   
                                        </Grid>
                                        : <></>
                                    )
                                )
                            )
                        }                    
                    </Grid>                       
                </FormProvider>
            </Grid>
        </AccordionPanel>
    )
}
export default Panel10;
